var map = {
	"./avatar.jpeg": 864,
	"./fifty_shades.jpg": 235,
	"./friends.jpeg": 18,
	"./homepage-bg.jpeg": 867,
	"./jane_eyre.jpg": 912,
	"./litcircle-logo.png": 361,
	"./pride_and_prejudice.jpg": 682,
	"./rest_and_relaxation.jpg": 736,
	"./wuthering_heights.jpg": 396
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 206;